/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const configRouter = {
  path: '/configuration',
  component: Layout,
  redirect: '/configuration/configuration',
  name: 'Nested',
  meta: {
    title: 'Cấu hình',
    icon: 'list'
  },
  children: [
    {
      path: 'configuration',
      name: 'Chung',
      redirect: '/configuration/configuration/model',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      meta: { title: 'Chung' },
      children: [
        {
          path: 'model',
          component: () =>
            import(
              '@/views/mci/configuration/configuration/model/configurationModel.vue'
            ),
          // redirect: '/configuration/configuration/model/view',
          name: 'Cấu hình mẫu',
          meta: { title: 'Cấu hình mẫu' }
          // children: [
          //   {
          //     path: 'view',
          //     component: () => import('@/views/mci/configuration/configuration/model/configurationModel.vue'),
          //     name: 'Xem cấu hình mẫu'
          //   },
          //   {
          //     path: 'add',
          //     component: () => import('@/views/mci/configuration/configuration/model/addModel.vue'),
          //     name: 'Thêm cấu hình mẫu'
          //   },
          //   {
          //     path: 'modify',
          //     component: () => import('@/views/mci/configuration/configuration/model/modifyModel.vue'),
          //     name: 'Sửa cấu hình mẫu'
          //   }
          // ]
        },
        {
          path: 'customer-profile',
          component: () =>
            import(
              '@/views/mci/configuration/configuration/configurationCustomerProfile.vue'
            ),
          name: 'Mẫu ghi chú hồ sơ khách',
          meta: { title: 'Mẫu ghi chú hồ sơ khách' }
        },
        {
          path: 'global-parameters-config',
          component: () =>
            import(
              '@/views/mci/configuration/configuration/configurationParameters.vue'
            ),
          name: 'Cấu hình tham số chung',
          meta: { title: 'Cấu hình tham số chung' }
        }
      ]
    },
    {
      path: 'hotel',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Khách sạn',
      meta: { title: 'Khách sạn' },
      redirect: '/configuration/hotel/hotel',
      children: [
        {
          path: 'shift',
          component: () => import('@/views/mci/configuration/hotel/shift.vue'),
          name: 'Ca',
          meta: { title: 'Ca' }
        },
        {
          path: 'hotel',
          component: () => import('@/views/mci/configuration/hotel/hotel.vue'),
          name: 'Khách sạn',
          meta: { title: 'Khách sạn' }
        },
        {
          path: 'room',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Phòng',
          meta: { title: 'Phòng' },
          redirect: '/configuration/hotel/room/room-category',
          children: [
            {
              path: 'room-properties',
              component: () =>
                import(
                  '@/views/mci/configuration/hotel/Room/roomProperties.vue'
                ),
              name: 'Thuộc tính phòng',
              meta: { title: 'Thuộc tính phòng' }
            },
            {
              path: 'room-category',
              component: () =>
                import('@/views/mci/configuration/hotel/Room/roomLevel.vue'),
              name: 'Hạng phòng',
              meta: { title: 'Hạng phòng' }
            },
            {
              path: 'room',
              component: () =>
                import('@/views/mci/configuration/hotel/Room/room.vue'),
              name: 'Phòng',
              meta: { title: 'Phòng' }
            },
            {
              path: 'room-reasonRefuse',
              component: () =>
                import('@/views/mci/configuration/hotel/Room/reasonRefuse.vue'),
              name: 'Lý do ngừng sử dụng/không phục vụ',
              meta: { title: 'Lý do ngừng sử dụng/không phục vụ' }
            },
            {
              path: 'room-diagram',
              component: () =>
                import('@/views/mci/configuration/hotel/Room/roomDiagram.vue'),
              name: 'Sơ đồ phòng',
              meta: { title: 'Sơ đồ phòng' }
            }
          ]
        },
        {
          path: 'statistic',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Thống kê',
          meta: { title: 'Thống kê' },
          redirect: '/configuration/hotel/statistic/source-group',
          children: [
            {
              path: 'source-group',
              component: () =>
                import(
                  '@/views/mci/configuration/hotel/Statistic/sourceGroup.vue'
                ),
              name: 'Nhóm nguồn',
              meta: { title: 'Nhóm nguồn' }
            },
            {
              path: 'source',
              component: () =>
                import('@/views/mci/configuration/hotel/Statistic/source.vue'),
              name: 'Nguồn',
              meta: { title: 'Nguồn' }
            },
            {
              path: 'market-segment-group',
              component: () =>
                import(
                  '@/views/mci/configuration/hotel/Statistic/marketSegmentGroup.vue'
                ),
              name: 'Nhóm phân khúc thị trường',
              meta: { title: 'Nhóm phân khúc thị trường' }
            },
            {
              path: 'market-segment',
              component: () =>
                import(
                  '@/views/mci/configuration/hotel/Statistic/marketSegment.vue'
                ),
              name: 'Phân khúc thị trường',
              meta: { title: 'Phân khúc thị trường' }
            },
            {
              path: 'language',
              component: () =>
                import(
                  '@/views/mci/configuration/hotel/Statistic/language.vue'
                ),
              name: 'Ngôn ngữ',
              meta: { title: 'Ngôn ngữ' }
            },
            {
              path: 'vip',
              component: () =>
                import('@/views/mci/configuration/hotel/Statistic/vip.vue'),
              name: 'VIP',
              meta: { title: 'VIP' }
            }
          ]
        }
      ]
    },
    // menu level 2
    {
      path: 'business_area',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Khu kinh doanh',
      meta: { title: 'Khu kinh doanh' },
      children: [
        {
          path: 'business_area_config',
          component: () =>
            import('@/views/mci/configuration/businessArea/businessArea.vue'),
          name: 'Khu kinh doanh',
          meta: { title: 'Khu kinh doanh' }
        },
        // {
        //   path: 'business_area_parameter_config',
        //   component: () =>
        //     import('@/views/mci/configuration/businessArea/businessArea.vue'),
        //   name: 'Tham số',
        //   meta: { title: 'Tham số' }
        // },
        // {
        //   path: 'bar_location',
        //   component: () =>
        //     import('@/views/mci/configuration/businessArea/businessArea.vue'),
        //   name: 'Vị trí',
        //   meta: { title: 'Vị trí' }
        // },
        // {
        //   path: 'bar_table',
        //   component: () =>
        //     import('@/views/mci/configuration/businessArea/businessArea.vue'),
        //   name: 'Phòng/bàn',
        //   meta: { title: 'Phòng/bàn' }
        // },
        // {
        //   path: 'business_area_map_config',
        //   component: () =>
        //     import('@/views/mci/configuration/businessArea/businessArea.vue'),
        //   name: 'Sơ đồ khu kinh doanh',
        //   meta: { title: 'Sơ đồ khu kinh doanh' }
        // },
        {
          path: 'business_area_shift_config',
          component: () =>
            import('@/views/mci/configuration/businessArea/businessShift.vue'),
          name: 'Ca',
          meta: { title: 'Ca' }
        }
        // {
        //   path: 'business_area_printer_config',
        //   component: () =>
        //     import('@/views/mci/configuration/businessArea/businessArea.vue'),
        //   name: 'Máy in',
        //   meta: { title: 'Máy in' }
        // },
        // {
        //   path: '/business_area_permission',
        //   component: () =>
        //     import('@/views/mci/configuration/businessArea/businessArea.vue'),
        //   name: 'Phân quyền',
        //   meta: { title: 'Phân quyền' }
        // }
      ]
    },
    {
      path: 'service-and-policy',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Dịch vụ, chính sách & giá bán',
      meta: { title: 'Dịch vụ, chính sách & giá bán' },
      redirect:
        '/configuration/service-and-policy/hotel/early-and-late-check-in',
      children: [
        {
          path: 'hotel',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Khách sạn',
          meta: { title: 'Khách sạn' },
          redirect:
            '/configuration/service-and-policy/hotel/early-and-late-check-in',
          children: [
            {
              path: 'early-and-late-check-in',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/earlyAndLateCheckin.vue'
                ),
              name: 'Nhận phòng sớm, trả phòng muộn',
              meta: { title: 'Nhận phòng sớm, trả phòng muộn' }
            },
            {
              path: 'cancel-check-in',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/cancelCheckin.vue'
                ),
              name: 'Hủy/Không đến',
              meta: { title: 'Hủy/Không đến' }
            },
            {
              path: 'package-category',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/packageCategory.vue'
                ),
              name: 'Danh mục gói',
              meta: { title: 'Danh mục gói' }
            },
            {
              path: 'package-group',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/packageGroup.vue'
                ),
              name: 'Nhóm gói',
              meta: { title: 'Nhóm gói' }
            },
            {
              path: 'package',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/package/index.vue'
                ),
              name: 'Gói',
              meta: { title: 'Gói' }
            },
            {
              path: 'package-diary',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/packageDiary.vue'
                ),
              name: 'Nhật ký gói',
              meta: { title: 'Nhật ký gói' }
            },
            {
              path: 'price-list',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/priceList.vue'
                ),
              name: 'Danh mục giá',
              meta: { title: 'Danh mục giá' }
            },
            {
              path: 'price-code',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/priceCode/index.vue'
                ),
              name: 'Mã giá',
              meta: { title: 'Mã giá' }
            },
            {
              path: 'price-per-day',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/pricePerDay.vue'
                ),
              name: 'Giá phòng theo ngày',
              meta: { title: 'Giá phòng theo ngày' }
            },
            {
              path: 'add-charge',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/addCharge.vue'
                ),
              name: 'Phụ thu phòng',
              meta: { title: 'Phụ thu phòng' }
            },
            {
              path: 'breakfast',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/breakfast.vue'
                ),
              name: 'Ăn sáng',
              meta: { title: 'Ăn sáng' }
            },
            {
              path: 'exceptional-service',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/exceptionalService.vue'
                ),
              name: 'Dịch vụ đặc biệt',
              meta: { title: 'Dịch vụ đặc biệt' }
            },
            {
              path: 'room-service-group',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/roomServiceGroup/index.vue'
                ),
              name: 'Nhóm dịch vụ buồng phòng',
              meta: { title: 'Nhóm dịch vụ buồng phòng' }
            },
            {
              path: 'reason-cancel',
              component: () =>
                import(
                  '@/views/mci/configuration/serviceAndPolicyAndPrice/reasonCancel.vue'
                ),
              name: 'Lý do hủy phòng',
              meta: { title: 'Lý do hủy phòng' }
            }
          ]
        }
      ]
    },
    // hi
    {
      path: 'profile',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Hồ sơ',
      meta: { title: 'Hồ sơ' },
      redirect: '/configuration/profile/company',
      children: [
        {
          path: 'company',
          component: () =>
            import('@/views/mci/configuration/profile/company/index.vue'),
          name: 'Hồ sơ công ty, đại lý du lịch',
          meta: { title: 'Hồ sơ công ty, đại lý du lịch' }
        },
        {
          path: 'customer',
          component: () =>
            import('@/views/mci/configuration/profile/customer/index.vue'),
          name: 'Hồ sơ khách',
          meta: { title: 'Hồ sơ khách' }
        },
        {
          path: 'company-with-invoice',
          component: () =>
            import(
              '@/views/mci/configuration/profile/companyWithInvoice/index.vue'
            ),
          name: 'Hồ sơ công ty xuất hóa đơn',
          meta: { title: 'Hồ sơ công ty xuất hóa đơn' }
        }
      ]
    },
    {
      path: 'user-config',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Cấu hình người dùng',
      meta: { title: 'Cấu hình người dùng' },
      redirect: '/configuration/user-config/group-user',
      children: [
        {
          path: 'group-user',
          component: () =>
            import('@/views/mci/configuration/userConfig/groupUser/index.vue'),
          name: 'Nhóm người dùng',
          meta: { title: 'Nhóm người dùng' }
        },
        {
          path: 'user',
          component: () =>
            import('@/views/mci/configuration/userConfig/user/index.vue'),
          name: 'Người dùng',
          meta: { title: 'Người dùng' }
        },
        {
          path: 'department',
          component: () =>
            import('@/views/mci/configuration/userConfig/department/index.vue'),
          name: 'Bộ phận',
          meta: { title: 'Bộ phận' }
        },
        {
          path: 'authorization',
          component: () =>
            import(
              '@/views/mci/configuration/userConfig/authorization/index.vue'
            ),
          name: 'Phân quyền',
          meta: { title: 'Phân quyền' }
        }
      ]
    },
    {
      path: 'system_module_connection',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Cấu hình kết nối',
      meta: { title: 'Cấu hình kết nối' },
      redirect: '/configuration/system_module_connection/iptv',
      children: [
        {
          path: 'iptv',
          component: () =>
            import('@/views/mci/configuration/connectConfig/iptv/index.vue'),
          name: 'IPTV',
          meta: { title: 'IPTV' }
        },
        {
          path: 'hotline',
          component: () =>
            import('@/views/mci/configuration/connectConfig/hotline/index.vue'),
          name: 'Tổng đài',
          meta: { title: 'Tổng đài' }
        },
        // {
        //   path: 'electronic-lock',
        //   component: () =>
        //     import(
        //       '@/views/mci/configuration/connectConfig/electronicLock/index.vue'
        //     ),
        //   name: 'Khóa từ',
        //   meta: { title: 'Khóa từ' }
        // },

        {
          path: 'department',
          component: () =>
            import('@/views/mci/configuration/userConfig/department/index.vue'),
          name: 'Bộ phận',
          meta: { title: 'Bộ phận' }
        },
        {
          path: 'hotel_link',
          name: 'Hotel Link',
          meta: {
            title: 'Hotel Link',
            icon: ''
          },
          component: () => import('@/views/nested/menu1/index'),
          redirect:
            '/configuration/system_module_connection/hotel_link/hotel_link_config',

          children: [
            {
              path: 'hotel_link_config',
              name: 'Cấu hình',
              meta: {
                title: 'Cấu hình'
              },
              component: () =>
                import(
                  '@/views/mci/configuration/userConfig/hotel-link/hotelLinkConfig.vue'
                )
            },
            {
              path: 'hotel_link_dashboard',
              name: 'Dashboard',
              meta: {
                title: 'Dashboard'
              },
              component: () =>
                import(
                  '@/views/mci/configuration/userConfig/hotel-link/hotelLinkDashboard.vue'
                )
            }
          ]
        }
      ]
    },
    {
      path: 'diary',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Nhật ký',
      meta: { title: 'Nhật ký' },
      redirect: '/configuration/diary/system',
      children: [
        {
          path: 'system',
          component: () =>
            import(
              '@/views/mci/configuration/diary/system/ListSystemLogPage.vue'
            ),
          name: 'Nhật ký hệ thống',
          meta: { title: 'Nhật ký hệ thống' }
        },
        {
          path: 'connect',
          component: () =>
            import('@/views/mci/configuration/diary/connect/index.vue'),
          name: 'Nhật ký kết nối',
          meta: { title: 'Nhật ký kết nối' }
        },
        {
          path: 'sync-data',
          component: () =>
            import('@/views/mci/configuration/diary/syncData/index.vue'),
          name: 'Nhật ký đồng bộ dữ liệu',
          meta: { title: 'Nhật ký đồng bộ dữ liệu' }
        }
      ]
    },
    {
      path: 'warehouse-config',
      component: () => import('@/views/nested/menu1/index'),
      name: 'Kho',
      meta: { title: 'Kho' },
      redirect: '/configuration/warehouse-config/warehouse-list',
      children: [
        {
          path: 'warehouse-list',
          component: () =>
            import('@/views/mci/configuration/warehouse/warehouseList.vue'),
          name: 'Danh sách kho',
          meta: { title: 'Danh sách kho' }
        }
      ]
    },
    {
      path: 'accounting',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Kế toán',
      meta: { title: 'Kế toán' },
      redirect: '/configuration/accounting/sub_transaction_type',
      children: [
        {
          path: 'product',
          component: () => import('@/views/nested/menu1/index'),
          redirect: '/configuration/accounting/product/product_category',
          name: 'Sản phẩm',
          meta: { title: 'Sản phẩm' },
          children: [
            {
              path: 'product_category',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/product/productCategory.vue'
                ),
              name: 'productCategory',
              meta: { title: 'Danh mục sản phẩm' }
            },
            {
              path: 'business_service_type',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/product/serviceType.vue'
                ),
              name: 'serviceType',
              meta: { title: 'Loại sản phẩm/dịch vụ' }
            },
            {
              path: 'product_attribute_category',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/product/attributeCategory.vue'
                ),
              name: 'attributeCategory',
              meta: { title: 'Danh mục thuộc tính' }
            },
            {
              path: 'product_attribute',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/product/attribute.vue'
                ),
              name: 'attribute',
              meta: { title: 'Thuộc tính' }
            },
            {
              path: 'product_unit_list',
              component: () =>
                import('@/views/mci/configuration/accounting/product/unit.vue'),
              name: 'unit',
              meta: { title: 'Đơn vị tính' }
            },
            {
              path: 'product_list',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/product/product.vue'
                ),
              name: 'product',
              meta: { title: 'Sản phẩm' }
            },
            {
              path: 'material_quantification',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/product/materialQuantification.vue'
                ),
              name: 'materialQuantification',
              meta: { title: 'Khai báo định lượng' }
            }
          ]
        },
        {
          path: 'sub_transaction_type',
          component: () =>
            import(
              '@/views/mci/configuration/accounting/subTransaction/subTransaction.vue'
            ),
          name: 'Loại giao dịch phụ',
          meta: { title: 'Loại giao dịch phụ' }
        },
        {
          path: 'transaction_definition',
          component: () =>
            import('@/views/mci/configuration/accounting/transaction.vue'),
          name: 'Giao dịch',
          meta: { title: 'Giao dịch' }
          // redirect: '/nested/menu1/menu1-2/menu1-2-1',
          // children: [
          //   {
          //     path: 'menu1-2-1',
          //     component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
          //     name: 'Menu1-2-1',
          //     meta: { title: 'Menu 1-2-1' }
          //   },
          //   {
          //     path: 'menu1-2-2',
          //     component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
          //     name: 'Menu1-2-2',
          //     meta: { title: 'Menu 1-2-2' }
          //   }
          // ]
        },
        {
          path: 'pay',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Thanh toán',
          meta: { title: 'Thanh toán' },
          redirect: '/configuration/accounting/pay/hotel',
          children: [
            {
              path: 'hotel',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/payment/hotel.vue'
                ),
              name: 'Khách sạn',
              meta: {
                title: 'Khách sạn'
              }
            },
            {
              path: 'other',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/payment/other.vue'
                ),
              name: 'Khu kinh doanh',
              meta: {
                title: 'Khu kinh doanh'
              }
            }
          ]
        },
        {
          path: 'deposit',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Đặt cọc',
          meta: { title: 'Đặt cọc' },
          redirect: '/configuration/accounting/deposit/hotel',
          children: [
            {
              path: 'hotel',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/deposit/hotel.vue'
                ),
              name: 'Khách sạn',
              meta: {
                title: 'Khách sạn'
              }
            },
            {
              path: 'other',
              component: () =>
                import(
                  '@/views/mci/configuration/accounting/deposit/other.vue'
                ),
              name: 'Khu kinh doanh',
              meta: {
                title: 'Khu kinh doanh'
              }
            }
          ]
        },
        {
          path: 'refund',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Hoàn tiền',
          meta: { title: 'Hoàn tiền' },
          redirect: '/configuration/accounting/refund/hotel',
          children: [
            {
              path: 'hotel',
              component: () =>
                import('@/views/mci/configuration/accounting/refund/hotel.vue'),
              name: 'Khách sạn',
              meta: {
                title: 'Khách sạn'
              }
            },
            {
              path: 'other',
              component: () =>
                import('@/views/mci/configuration/accounting/refund/other.vue'),
              name: 'Khu kinh doanh',
              meta: {
                title: 'Khu kinh doanh'
              }
            }
          ]
        },
        {
          path: 'copy',
          component: () =>
            import(
              '@/views/mci/configuration/accounting/assignTransaction/assignTransaction.vue'
            ),
          name: 'Gán giao dịch vào dịch vụ, sản phẩm',
          meta: { title: 'Gán giao dịch vào dịch vụ, sản phẩm' }
        },
        {
          path: 'currency',
          component: () =>
            import('@/views/mci/configuration/accounting/currency.vue'),
          name: 'Tiền tệ',
          meta: { title: 'Tiền tệ' }
        },
        {
          path: 'bank-account',
          component: () =>
            import('@/views/mci/configuration/accounting/bankAccount.vue'),
          name: 'Tài khoản ngân hàng',
          meta: { title: 'Tài khoản ngân hàng' }
        },
        {
          path: 'charge-fee',
          component: () =>
            import('@/views/mci/configuration/accounting/chargeFee.vue'),
          name: 'Phí dịch vụ',
          meta: { title: 'Phí dịch vụ' }
        },
        {
          path: 'tax',
          component: () =>
            import('@/views/mci/configuration/accounting/tax.vue'),
          name: 'Thuế',
          meta: { title: 'Thuế' }
        }
      ]
    },
    {
      path: 'promotions_system',
      component: () =>
        import('@/views/mci/configuration/promotions/PromotionList.vue'),
      // component: () => import('@/views/mci/configuration/promotions/index.vue'),
      name: 'Hệ thống khuyến mại',
      meta: { title: 'Hệ thống khuyến mại' }
    },
    {
      path: 'room-sales-quantity-in-website',
      component: () =>
        import(
          '@/views/mci/configuration/roomSalesQuantityInWebsite/index.vue'
        ),
      // component: () => import('@/views/mci/configuration/promotions/index.vue'),
      name: 'Cấu hình số lượng phòng được bán trên website',
      meta: { title: 'Cấu hình số lượng phòng được bán trên website' }
    },
    {
      path: 'key_managemnet',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      name: 'Quản lý khóa phòng',
      meta: { title: 'Quản lý khóa phòng' },
      redirect: '/configuration/key_managemnet/electronic-lock',
      children: [
        {
          path: 'electronic-lock',
          component: () =>
            import(
              '@/views/mci/configuration/lockManagement/electronicLock/index.vue'
            ),
          name: 'Khóa từ',
          meta: { title: 'Khóa từ' }
        },
        {
          path: 'room_assignment',
          component: () =>
            import(
              '@/views/mci/configuration/lockManagement/assignRoom/index.vue'
            ),
          name: 'Cắt khóa cho nhân viên',
          meta: { title: 'Cắt khóa cho nhân viên' }
        }
      ]
    },
    {
      path: 'notification',
      component: () =>
        import('@/views/mci/configuration/notification/NotificationPage.vue'),
      name: 'Thông báo',
      meta: { title: 'Thông báo' }
    }
  ]
}

export default configRouter
